// import { checkBrowser } from '../../plugin/channel/setUserChannel'
/**
 *
 * 解决h5下微信环境和支付宝环境下标题不更新的问题
 *
 * @param {string} title
 */
export const setDocumentTitle = function (title) {
  const titleEle = document.getElementsByTagName('title') && document.getElementsByTagName('title')[0]

  // eslint-disable-next-line no-undef
  // if (checkBrowser() === 'ALIPAY') {
  //   // eslint-disable-next-line no-undef
  //   ant.setTitle(title)
  //   return
  // }
  if (titleEle && titleEle.innerHTML) {
    titleEle.innerHTML = title
  }
}
